import { render, staticRenderFns } from "./EpsAttachmentsConfig.vue?vue&type=template&id=2fe2aeda&"
import script from "./EpsAttachmentsConfig.vue?vue&type=script&lang=js&"
export * from "./EpsAttachmentsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports